import React from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import { variantPropType, FILE_HANDLER_VARIANTS, Variant } from '../consts';
import FilenameTooltip from './FilenameTooltip';

type NameProps = StylableComponent<HTMLDivElement> & {
  variant?: Variant;
  disabled?: boolean;
};

const Name = React.forwardRef<HTMLDivElement, NameProps>(
  ({ className, style, variant, disabled, children, ...props }, ref) => {
    const theme = useTheme();
    const nameTokens = theme.tokens?.component?.fileHandler?.name;
    const isRemoved = variant === FILE_HANDLER_VARIANTS.REMOVED;

    return (
      <div
        {...props}
        ref={ref}
        className={className}
        css={[
          nameTokens?._,
          nameTokens?.disabled?.[disabled ? 'true' : 'false'],
          nameTokens?.removed?.[isRemoved ? 'true' : 'false'],
          style,
        ]}
      >
        <FilenameTooltip name={children as string} />
      </div>
    );
  },
);

Name.displayName = 'Name';

Name.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The style variant */
  variant: variantPropType,
  /** If the file is disabled (removed or loading variant) */
  disabled: PropTypes.bool,
  children: PropTypes.any,
};

export default Name;
